var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{staticClass:"m-table-header-row"},[_vm._t("default"),_vm._v(" "),_vm._m(0)],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('th',{staticClass:"m-table-header m-table-header_indicator_row"},[_c('div',{attrs:{"id":"m-table-header-lazy-resize-indicator"}})])
}]

export { render, staticRenderFns }